import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { BundleSection } from '../components/BundleSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmpathySection } from '../components/EmpathySection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { DecisionSection } from '../components/DecisionSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-328">
      <AnnouncementBar data-id="element-329" />
      <HeroSection data-id="element-330" />
      <SocialProofSection data-id="element-331" />
      <SuccessInsert data-id="element-332" />
      <ConnectionInsert data-id="element-333" />
      <BundleSection data-id="element-334" />
      <TestimonialsSection data-id="element-335" />
      <EmpathySection data-id="element-336" />
      <OrderBumpSection data-id="element-337" />
      <DecisionSection data-id="element-338" />
      <FAQSection data-id="element-339" />
      <Footer data-id="element-340" />
      <StickyButton data-id="element-341" />
    </main>;
}